import Form, {
  formCreate,
} from '../../../../../../components/form';
import Budget from './budget.vue';

formCreate.component('Budget', Budget);
export default {
  name: 'form-change',
  extends: Form,
  props: {
    rules: Array,
    formConfig: Object,
    value: Object,
  },
  data() {
    return {
      formFunctionCode: 'tpm_budget_fee_change',
      formParentCode: 'CRM20260203000000002',
      buttons: {
        submit: false,
        close: false,
        loading: false,
        submitAudit: false,
      },
    };
  },
  components: {
    formCreate: formCreate.$form(),
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          const that = this;
          setTimeout(() => {
            that.setValue({
              ...val,
            });
            that.$emit('setChangeData', that);
          }, 1000);
        }
      },
    },
  },
  mounted() {},
  methods: {
    // 设置rule
    setRule(item) {
      const v = item;
      v.props = {
        ...v.props,
        disabled: true,
      };
      if (v.field === 'srcFeeBudgetCode') {
        v.props = {
          ...v.props,
          params: {
            functionCode: 'tpm_fee_budget',
            parentCode: 'CRM20260203000000002',
            paramData: {},
          },
          title: v.title,
        };
      } else if (v.field === 'afterAdjustAmount') {
        v.props = {
          ...v.props,
          disabled: true,
        };
      } else if (v.field === 'changeAmount') {
        v.props = {
          ...v.props,
          controls: false,
          min: 0,
          disabled: true,
        };
      }
      if (v.field === 'businessRemarks' || v.field === 'changeType') {
        v.props = {
          ...v.props,
          disabled: false,
        };
      }
      if (v.field === 'attachmentList') {
        v.props = {
          ...v.props,
          disabled: false,
          fileMsg: '请上传pdf,docx,xlsx,ppt,png,jpg等格式,仅能上传一个',
          limit: 1,
        };
      }
      return v;
    },
    // 两个浮点数求和
    accAdd(num1, num2) {
      let r1;
      let r2;
      let m = 0;
      try {
        r1 = num1.toString().split('.')[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = num2.toString().split('.')[1].length;
      } catch (e) {
        r2 = 0;
      }
      // eslint-disable-next-line no-restricted-properties
      m = Math.pow(10, Math.max(r1, r2));
      return Math.round(num1 * m + num2 * m) / m;
    },
    // 两个浮点数相减
    accSub(num1, num2) {
      let r1;
      let r2;
      let m = 0;
      try {
        r1 = num1.toString().split('.')[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = num2.toString().split('.')[1].length;
      } catch (e) {
        r2 = 0;
      }
      // eslint-disable-next-line no-restricted-properties
      m = Math.pow(10, Math.max(r1, r2));
      // eslint-disable-next-line no-restricted-properties
      const n = (r1 >= r2) ? r1 : r2;
      return (Math.round(num1 * m - num2 * m) / m).toFixed(n);
    },
    // 表单渲染完成后回调
    formComplete() {
      const changeType = this.getRule('changeType');
      const canUseAmount = this.getRule('canUseAmount');
      const changeAmount = this.getRule('changeAmount');

      // 变更选择 费用预算
      const srcFeeBudgetCode = this.getRule('srcFeeBudgetCode');
      srcFeeBudgetCode.on = {
        ...srcFeeBudgetCode.on,
        change: (e) => {
          if (e && e.length) {
            const obj = e[0];
            this.setValue({
              srcFeeBudgetCode: obj.feeBudgetCode,
              feeBudgetType: obj.feeBudgetType,
              ext1: obj.ext1,
              orgName: obj.orgName,
              budgetSubjectsName: obj.budgetSubjectsName,
              ext8: obj.ext8,
              productLevelName: obj.productLevelName,
              canUseAmount: obj.canUseAmount,
              remarks: obj.remarks,
            });
          } else {
            this.setValue({
              srcFeeBudgetCode: null,
              feeBudgetType: null,
              ext1: null,
              orgName: null,
              budgetSubjectsName: null,
              ext8: null,
              productLevelName: null,
              canUseAmount: null,
              remarks: null,
              changeAmount: null,
              afterAdjustAmount: null,
            });
          }
          this.$emit('setChangeData', this);
        },
      };

      // 变更类型
      changeType.on = {
        ...changeType.on,
        change: (e) => {
          const allVal = canUseAmount.value;
          const val = changeAmount.value;
          this.disabled(!e, 'changeAmount');
          if (e === 'additional' && val && Number(val) !== 0) {
            this.setValue({
              afterAdjustAmount: this.accAdd(Number(allVal), Number(val)),
            });
          } else if (e === 'cut_out' && val && Number(val) !== 0) {
            this.setValue({
              afterAdjustAmount: this.accSub(Number(allVal), Number(val)),
            });
          } else {
            this.setValue({
              changeAmount: '',
              afterAdjustAmount: allVal,
            });
          }
          this.$emit('setChangeData', this);
        },
      };

      // 变更金额
      changeAmount.on = {
        ...changeAmount.on,
        change: (e) => {
          const type = changeType.value;
          const val = canUseAmount.value;
          if (type === 'additional') {
            this.setValue({
              afterAdjustAmount: this.accAdd(Number(val), Number(e || 0)),
            });
          } else {
            this.setValue({
              afterAdjustAmount: this.accSub(Number(val), Number(e || 0)),
            });
          }
          this.$emit('setChangeData', this);
        },
      };
    },
  },
};
